<template>
  <div class="know">
    <!--轮播图广告-->
    <div class="banner-bg">
      <swipe-ad :reqData="{adType: 'SYS', version: 3}"></swipe-ad>
      <swipe-nav class="kn-swipe" :reqData="{navType: 1, version: 3}"></swipe-nav>
    </div>

    <div class="mall-nav-goods">
      <div class="introduce" v-if="tipsData.length>0">
        <div class="img-con" @click="onTipsClick(tipsData[0])">
          <img class="img" :src="tipsData[0].picUrl" alt="">
        </div>
      </div>

      <!--<div class="bg-10px"></div>-->

      <!--热门推荐-->
      <div class="goods-popular">
        <van-cell class="goods-popular-con" :border="false">
          <template slot="title">
            <img class="popular-icon" src="../../../assets/mall/popular-icon.png" alt="">
            <span class="popular-title">热门推荐</span>
          </template>
          <div class="popular-more" slot="right-icon" @click="popularMore">
            <span class="more">更多</span>
            <van-icon class="van-cell__right-icon" name="arrow" />
          </div>
        </van-cell>
        <div class="popular-con">
          <div class="popular-recommend">
            <div class="item" v-for="(item, i) in POPULARITYitems" :key="i" @click="goDetail(item)">
              <img class="img" :src="item.filePath[0]+'?imageView2/0/w/360/h/270'" alt="">
              <div class="item-text">
                <div class="item-title"><span class="type">{{ knowledgeTypeName(item.products[0].courseType) }}</span>{{ item.products[0].productTitle }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--<div class="bg-10px"></div>-->

      <!--商品-精选、最新、价格-->
      <div  class="goods-list-con">
        <div class="goods-tabs" :class="{'goods-tabs-on-top': (mallActive===2 && goodsTabsOnTop)}">
          <div class="goods-tab" :class="{'goods-tab-active': goodsListActive===1}" @click="goodsTabChange('PERSONALIZED')">
            <div class="tab-title">精选</div>
            <div class="line-con"><i class="line"></i></div>
          </div>
          <div class="goods-tab" :class="{'goods-tab-active': goodsListActive===2}" @click="goodsTabChange('TIME')">
            <div class="tab-title">最新</div>
            <div class="line-con"><i class="line"></i></div>
          </div>
          <div class="goods-tab" :class="{'goods-tab-active': goodsListActive===3 || goodsListActive===4,
               'goods-tab-active-DESC': goodsListActive===3, 'goods-tab-active-ASC': goodsListActive===4}" @click="goodsTabChange('PRICE')">
            <div class="tab-title price-btn">价格 <span class="icon"><i class="top"></i><i class="bottom"></i></span></div>
            <div class="line-con"><i class="line"></i></div>
          </div>
        </div>
        <!--商品列表-->
        <div class="goods-list">
          <!--<van-pull-refresh v-model="goodsItemsRefreshLoading" @refresh="onGoodsItemsRefresh"></van-pull-refresh>-->
          <van-list
              class="goods-con"
              v-model="goodsItemsLoading"
              :finished="goodsItemsFinished"
              :error.sync="goodsItemsIsError"
              error-text="请求失败，点击重新加载"
              finished-text="没有更多了"
              @load="getGoods"
          >
            <div class="list" v-for="(item, i) in goodsItems" :key="i" @click="goDetail(item)">
              <div class="list-item">
                <div class="img-con">
                  <img class="img" :src="item.filePath[0]+'?imageView2/0/w/360/h/270'" alt="">
                  <div class="time-con">
                    <span class="num" v-if="item.products[0].courseType===null">已更新{{ item.products[0].currentCourseCount }}期</span>
                    <span class="num" v-if="item.products[0].courseType!==null">时长:{{ formatSeconds(item.products[0].courseType, item.products[0].duration) }}</span>
                  </div>
                  <div class="is-boutique" v-if="false"></div>
                  <div class="is-vip-shop" v-if="item.isVipShop"></div>
                  <div class="is-member-bag" v-if="item.isMemberBag"></div>
                </div>
                <div class="text-con">
                  <div class="list-title"><span class="type">{{ knowledgeTypeName(item.products[0].courseType) }}</span>{{ item.products[0].productTitle }}</div>
                  <div class="coin-text">
                    <span class="num">已售{{ item.products[0].salesVolume }}</span>
                    <span class="num">收藏{{ item.products[0].collectUserCount }}</span>
                  </div>
                  <div class="sub-text">
                    <span class="price">{{ item.products[0].sellPrice===0?'免费':('￥'+item.products[0].sellPrice) }}</span>

                  </div>
                </div>
              </div>

            </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters} from 'vuex';
import { listAd, listNav, tipsList } from '@/api/mall/mallContent'
import { mallGoods } from '@/api/mall/mallGoods'
import { columnDetail, courseDetail, directDetail } from '@/api/mall/mallGoods'
import SwipeAd from '@/components/swipeAd'
import swipeNav from '@/components/swipeNav'
export default {
  components:{
    SwipeAd,
    swipeNav
  },
  data(){
    return {
      swipeWidth: window.screen.width || 375,
      swipeHeight: (window.screen.width>375) ? 200 : 174,

      POPULARITYpage: 1,//当前页
      POPULARITYsize: 6,//分页大小
      POPULARITYtotalPages: 0,//总页数
      POPULARITYitems: [],
      //列表
      orderBy: 'PERSONALIZED', // SALES_VOLUME-销量；TIME-上架时间（最新）；PRICE-价格；PV-商品页浏览量；PERSONALIZED-个性化推荐（精选）
      sortOrder: 'DESC', // ASC-升序；DESC-降序
      goodsItems: [],
      goodsPage: 1,
      goodsSize: 20,
      goodsItemsRefreshLoading: false,
      goodsItemsLoading: false,
      goodsItemsFinished: false,
      goodsItemsIsError: false,

      goodsListActive: 1,// 商品tabs标签状态
      // goodsTabsOnTop: false,//商品tabs标签是否固定在顶部
      origin: window.location.origin,

      // 广告 , 导航 ，tip广告
      adList: [],
      navData: [],
      tipsData: [],
    }
  },
  computed:{
    ...mapGetters([
      'mallActive',
      'goodsTabsOnTop',
    ])
  },
  watch: {

  },
  created(){
    this.get_AD_and_Nav() // 获取商品热门推荐
    this.getGoodsPOPULARITY() // 获取商品热门推荐
  },
  methods: {
// 获取 商城首页的 广告 、 导航
    get_AD_and_Nav(){
      // listAd({adType: "SYS",clientType: "H5"}).then(res=>{ //获取广告
      //   this.adList = res.data
      // });
      listNav({navType: 1, clientType: "H5"}).then(res=>{ // 获取导航
        const lineCount = res.data.lineCount || 4;// 每行显示图标个数
        const arr = res.data.navItemlist || []; // icon 源数据
        const a = [], b = [];//缓存数据
        // 分组
        const ii = Math.ceil(arr.length/lineCount);
        for(let i = 0; i<ii; i++){
          a.push(arr.splice(0,lineCount))
        }
        //分页
        const kk = Math.ceil(a.length/2)
        for(let j = 0; j<kk; j++){
          b.push(a.splice(0,2))
        }
        this.navData = b;
        // console.log(this.navData)
      })
      tipsList().then(res=>{
        this.tipsData = res.data || [];
      })
    },
    // 点击广告时：
    adClick(item){
      console.log(item)
      switch (item.targetType){
        case 1: // 1-平台类目1级
        case 2: // 2-平台类目2级
        case 3: // 3-平台类目3级
          this.goCategoryMore({title: item.title, categoryId: item.targetId, level: item.targetType})
          break;
        case 4: // 4-店铺  跳转至店铺
          this.$router.push({name: 'mallShop', query: {shopId: item.targetId} })
          break;
        case 5: // 5-商品-课程
          this.getColumnDetail(item.targetId)
          break;
        case 6: // 6-商品-专栏
          this.getColumnDetail(item.targetId)
          break;
        case 7: // 7-商品-直播
          this.getDirectDetail(item.targetId)
          break;
        default:
          console.log(item)
          break;
      }
    },
    getColumnDetail(goodsId) { // 专栏详情
      columnDetail({goodsId}).then(res=>{
        this.$router.push({name: 'goodsDetail', query: {goodsId: res.data.goodsId, shopId: res.data.shopId, courseType: null } })
      })
    },
    getCourseDetail(goodsId) { // 课程详情(视频，音频)
      courseDetail({goodsId}).then(res=>{
        this.$router.push({name: 'goodsDetail', query: {goodsId: res.data.goodsId, shopId: res.data.shopId, courseType: res.data.type } })
      })
    },
    getDirectDetail(goodsId) { // 直播详情
      directDetail({goodsId}).then(res=>{
        this.$router.push({name: 'goodsDetail', query: {goodsId: res.data.goodsId, shopId: res.data.shopId, courseType: res.data.courseType } })
      })
    },
    goCategoryMore(category){
      console.log(category)
      this.session('category', category)
      this.$router.push({name: 'categoryMore'})
    },


    //tips跳转
    onTipsClick(item){
      if(item.type===1){
        this.session('videoSrc', item.jumpUrl)
        this.$router.push({name: 'tipVideo'})
      }
    },

    // 商城首页顶部的 tab 标签切换
    mallActiveChange(mallActive){
      console.log('mallActive: ' + mallActive)
      this.$store.dispatch('mall/changeMallActive', mallActive)
      // this.session('mallActive',this.mallActive)
    },



    // 热门推荐---->更多
    popularMore(){
      this.$router.push({name: 'popularMore'})
    },

    // 商品列表的 tab 标签切换
    goodsTabChange(orderBy){
      this.goodsPage = 1;//初始化分页
      if(this.goodsItemsFinished){
        this.goodsItemsFinished = false; //初始化分页
      }
      this.orderBy = orderBy;//排序字段
      this.sortOrder = 'DESC';// 默认降序
      if(orderBy==='PERSONALIZED'){ //精品
        this.goodsListActive = 1
      }else if(orderBy==='TIME'){//最新
        this.goodsListActive = 2
      }else if(orderBy==='PRICE'){//价格
        // this.goodsListActive = 3
        if(this.goodsListActive===3){
          this.sortOrder = 'DESC';//按价格降序
          this.goodsListActive = 4
        }else {
          this.sortOrder = 'ASC'; //按价格升序
          this.goodsListActive = 3
        }
      }
      this.getGoods()
    },
    // 获取 热门推荐 商品列表
    getGoodsPOPULARITY() {
      mallGoods({goodsType: 'KNOWLEDGE', orderBy: 'POPULARITY',sortOrder: 'DESC', page: this.POPULARITYpage, size: this.POPULARITYsize}).then(res=>{
        // console.log(res)
        this.POPULARITYtotalPages = res.data.totalPages
        this.POPULARITYitems = res.data.items
      })
    },
    // 获取 商品列表
    getGoods() {
      mallGoods({goodsType: 'KNOWLEDGE', orderBy: this.orderBy, page: this.goodsPage, size: this.goodsSize, sortOrder: this.sortOrder}).then(res=>{
        // console.log(res)
        // this.goodsItems = res.data.items
        if(res.data.totalCount){ //是否有数据
          let arr = res.data.items
          // 如果是第一页需手动制空列表
          if (this.goodsPage === 1){
            this.goodsItems = [];
          }
          // 把请求到的数据添加到列表
          this.goodsItems = this.goodsItems.concat(arr)
          this.goodsItemsLoading = false
          if(res.data.totalPages===this.goodsPage){ // 到达最大页
            this.goodsItemsFinished = true;
          }
          this.goodsPage++

        }else {
          this.goodsItemsLoading = false;
          this.goodsItemsFinished = true;
        }
      }).catch(() => {this.goodsItemsIsError = true;})
    },
    // 跳转至商品详情
    goDetail(item) {
      this.$router.push({name: 'goodsDetail', query: {goodsId: item.goodsId, shopId: item.shopId, courseType: item.products[0].courseType } })
    },

    onGoodsItemsRefresh(){
      this.goodsItemsFinished = true;
      this.goodsPage = 1;
      window.setTimeout(()=>{
        this.goodsItemsFinished = false;
        this.goodsItems = [];
        this.goodsItemsRefreshLoading = false;
        window.scrollTo(0, 0);
      },200)
    },
  }
}
</script>

<style lang="less" scoped>
.know{
  position: absolute;width: 100%;
  top: 0;bottom: 0;
  .advertisement-con{
    padding: 0 12px;
    .advertisement-swipe{
      border-radius: 5px;
      z-index: 10;
      width: 351px;
      height: 175px;
      .advertisement-swipe-img{
        width: 100%;height: 100%;
      }
    }
  }
  .mall-nav-goods{
    .nav-swipe{
      .classification{
        height: 174px;
        width: 100%;
        .nav-row{
          height: 48%;
          display: flex;
          .item{
            display: inline-flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex: 1;
            max-width: 25%;
            .item-img{
              display: block;
              width: 44px;
              height: 44px;
              margin-bottom: 10px;
            }
            .item-text{
              font-size: 12px;
              line-height: 16px;
              color: #2b2b2b;
            }
          }
        }
      }
      .nav-swipe-row-3 .classification .nav-row .item{max-width: 33.3%;}
      .nav-swipe-row-4 .classification .nav-row .item{max-width: 25%;}
      .nav-swipe-row-5 .classification .nav-row .item{max-width: 20%;
        .item-img{width: 36px;height: 36px;}
      }
      .nav-swipe-row-6 .classification .nav-row .item{max-width: 16.6%;
        .item-img{width: 30px;height: 30px;}
      }
    }
    .introduce{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px auto;
      .img-con{
        display: inline-flex;
        .img{
          width: 320px;height: 95px;
        }
      }
    }
    .goods-popular{
      position: relative;
      z-index: 0;
      background-color: #fff;
      .goods-popular-con{
        padding: 10px 12px;
        background-color: transparent;
        height: 44px;
        /deep/ .van-cell__title{
          display: inline-flex;
          align-items: center;
        }
        .popular-icon{
          display: block;
          width: 22px;
          height: 22px;
        }
        .popular-title{
          display: inline-flex;
          align-items: center;
          font-size: 16px;
          line-height: 1;
          height: 22px;
          font-weight: 600;
          color: #2b2b2b;
          padding-left: 10px;
        }
        .popular-more{
          .more{
            display: inline-block;
            vertical-align: top;
            color: #333;
            font-size: 12px;
            line-height: 24px;
          }
        }
      }
      .popular-con{
        width: 100%;
        height: 150px;
        padding: 0 12px 0;
        .popular-recommend{
          height: 100%;
          margin-bottom: 10px;
          overflow-x: auto;
          display: flex;
          flex-wrap: nowrap;
          .item{
            position: relative;
            z-index: 0;
            display: inline-flex;
            min-width: 180px;
            max-width: 181px;
            height: 135px;
            border-radius: 5px;
            margin-right: 10px;
            flex-direction: column;
            box-shadow: 0 0 .5px .5px #cdcdcd;
            overflow: hidden;
            .img{
              width: 100%;
              height: 100%;
              border-top-left-radius: 5px;
              border-top-right-radius: 5px;
            }
            .item-text{
              position: absolute;
              z-index: 0;
              color: #fff;
              background-color: rgba(0,0,0,.5);
              width: 100%;
              height: 32px;
              bottom: 0;

              .item-title{
                font-size: 12px;
                line-height: 34px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                .type{
                  margin: 0 5px;
                  font-size: 9px;
                  border: .75px solid #fff;
                  border-radius: 2px;
                  padding: 1px 2.5px;
                }
              }
              .red-text{
                font-size: 14px;
                color: #f74d4d;
                line-height: 1;
                padding: 4px 0 6px;
              }
              .sub-text{
                font-size: 10px;
                color: #999;
                line-height: 1;
                .popularity{
                  float: right;
                }
              }
            }
          }
        }

      }
    }
    .goods-list-con{
      position: relative;z-index: 0;padding-top: 44px;
      .goods-tabs{
        position: absolute;top: 0;width: 100%;background-color: #fff;
        display: flex;justify-content: center;align-items: center;
        height: 44px;font-size: 16px;color: #666;
        &.goods-tabs-on-top{
          position: fixed;z-index: 100;top: 68px;
        }
        .goods-tab{
          position: relative;z-index: 0;height: 100%;padding: 0 5px;
          flex: 1;display: inline-flex;justify-content: center;align-items: center;
          .price-btn{
            position: absolute;z-index: 0;right: 0;top: 0;
            width: 125px;height: 44px;font-size: 16px; /*color: #999;*/
            display: inline-flex;justify-content: center;align-items: center;
            .icon{
              width: 12px;height: 16px;
              display: inline-flex;flex-direction: column;justify-content: center;align-items: center;
              .top{
                display: inline-flex;width: 9px;height: 5px;margin-bottom: 2px;
                background: url("../../../assets/mall/sort-up.png") no-repeat 50% 50%;
                background-size: 100%;
              }
              .bottom{
                display: inline-flex;width: 9px;height: 5px;
                background: url("../../../assets/mall/sort-down.png") no-repeat 50% 50%;
                background-size: 100%;
              }
            }
          }
          &.goods-tab-active-DESC{
            .icon{
              .top{background: url("../../../assets/mall/sort-up-active.png") no-repeat 50% 50%;background-size: 100%;}
            }
          }
          &.goods-tab-active-ASC{
            .icon{
              .bottom{background: url("../../../assets/mall/sort-down-active.png") no-repeat 50% 50%;background-size: 100%;}
            }
          }
          &.goods-tab-active {
            color: #1585f3;
            .line-con{
              position: absolute;z-index: 0;bottom: 0;width: 100%;height: 4px;
              display: flex;justify-content: center;align-items: center;
              .line{
                display: block;width: 50px;height: 2px;
                background-color: #1585f3;
              }
            }
          }
        }
      }
      .goods-list{
        .goods-con{
          display: flex;justify-content: flex-start;
          flex-wrap: wrap;
          .list{
            width: 50%;height: 178px;margin: 8px 0;
            &:nth-child(2n-1){
              padding-left: 12px;padding-right: 8px;
            }
            &:nth-child(2n){
              padding-left: 8px;padding-right: 12px;
            }
            .list-item{
              width: 100%;height: 100%;
              border-top-left-radius: 5px;border-top-right-radius: 5px;
              box-shadow: 0px 0px .5px .5px rgba(0,0,0,0.25);
            }
            .img-con{
              position: relative;z-index: 0;width: 168px;height: 103px;
              .img{
                display: block;width: 168px;height: 103px;
                border-top-left-radius: 5px;border-top-right-radius: 5px;
              }
              .time-con{
                position: absolute;z-index: 0;left: 0;bottom: 0;width: 100%;
                background-color: rgba(0,0,0,.2);
                padding: 2px 0 2px 6px;font-size: 9px;color: #fff;
              }
              .is-boutique{
                position: absolute;z-index: 0;top: 0;left: 0;
                width: 25px;height: 15px;
                background: url("../../../assets/mall/goods-icon-boutique.png") no-repeat 50% 50%;
                background-size: 100%;
              }
              .is-vip-shop{
                position: absolute;z-index: 0;top: -9px;right: -4px;
                width: 26px;height: 19px;
                background: url("../../../assets/mall/goods-icon-vip.png") no-repeat 50% 50%;
                background-size: 100%;
              }
              .is-member-bag{
                position: absolute;z-index: 0;bottom: -14px;right: -4px;
                width: 32px;height: 39px;
                background: url("../../../assets/mall/goods-icon-member-bag.png") no-repeat 50% 50%;
                background-size: 100%;
              }
            }
            .text-con{
              flex: 1;padding: 0 4px;

              .list-title{
                margin: 4px 0 4px;
                font-size: 14px;
                padding: 2px;
                color: #2b2b2b;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                .type{
                  margin: 0 5px 0 0;
                  font-size: 9px;
                  border: .75px solid #1585f3;
                  color: #1585f3;
                  border-radius: 2px;
                  padding: 1px 2.5px;
                }
              }
              .coin-text{
                font-size: 9px;line-height: 20px;color: #999;
                .num{
                  padding-right: 10px;
                  /*.icon{
                    display: inline-flex;width: 8px;height: 8px;
                  }
                  .goods-num-icon1{

                    background: url("../../../assets/mall/goods-num-icon1.png") no-repeat 50% 50%;
                    background-size: 100%;
                  }
                  .goods-num-icon2{
                    background: url("../../../assets/mall/goods-num-icon2.png") no-repeat 50% 50%;
                    background-size: 100%;
                  }*/
                }
              }
              .sub-text{
                line-height: 19px;
                font-size: 9px;
                color: #999;
                .price{
                  font-size: 14px;
                  color: #f34b4b;
                }
              }
            }
          }
        }

      }
    }
  }
}
</style>